import React from "react";
import {
  Row,
  Col} from "reactstrap";
import "../../styles/estilos.css";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import Page from "components/Page";
import ValoresCotizacion from "../../components/CotizacionFinanciero/ValoresCotizacionFinanciero";
import ListadoProducto from "../../components/CotizacionFinanciero/ListadoProductoFinanciero";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {encriptarTramaAES} from "../../utils/Encriptar/index";
import {fetchConsultarCarritoFinanciero,fetchEnviarPDFFinanciero} from "../../redux/actions/aRamoLineaFinanciera";

class ContainerCotizacionFinanciero4 extends React.Component {
  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
  }

  async componentDidMount() {
    window.scroll(0, 0);
    const queryParams = new URLSearchParams(this.props.location.search);
    let datosJSON ='';
    if(queryParams.get('id') !== null){
        /*Consulta Carrito*/  
        datosJSON = {
          idCarrito: queryParams.get('id')
        }
    }else{   
      /*Consulta Carrito*/  
        datosJSON = {
          // idCarrito: this.props.detalleCarrito.datosCarritoFinanciero.ultimoPaso.resultado.idCarrito,
          idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito,
        }
    }
    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
    await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));
  }

  onClickEnviarPDF = async params => {
    const {correo,idCarrito} = params;

    const datosJSON = {
      idCarrito: idCarrito,
      correo: correo
      }

    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
    await this.props.setCorreo(Buffer.from(JSON.stringify(encriptado)).toString('base64'));  
}

  textosCargando() {
    if (this.props.detalleCarrito.consultarCarritoFinancieroIsLoading)
      return "Obteniendo datos de resumen..."
    if (this.props.datosEnviarPDFFinanciero.enviarPDFFinancieroIsLoading )
      return "Enviando Cotización al Cliente..."
  }


  /**
   * Regresar al anterior paso
   */
  async handleBack() {
      // actualizar los datos, para que se precarguen correctamente en el paso anterior
      const datosJSON = {
        idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito,
      }
      // encriptar body y enviar al servicio
      const encriptado = encriptarTramaAES(JSON.stringify(datosJSON))
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'))
      // actualizar el ultimo paso en el servicio
      // const datosJSON2 = {
      //   paso:`${paso}`,
      //   preguntas: {idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito}
      // }
      // const encriptado2 = await encriptarTramaAES(JSON.stringify(datosJSON2));
      // await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado2)).toString('base64')});
      if(/* this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion===undefined */ 
          !this.props.detalleCarrito.consultarCarritoFinancierohasError){
          /*Pasa a la siguiente pantalla*/      
          this.props.history.push({
            pathname: '/limites-cotizacion-financiero',
            search: `?${
              new URLSearchParams({
                preservar:'si'
              }).toString()
            }`
          });
      }
  }


  render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
              loading={this.props.detalleCarrito.consultarCarritoFinancieroIsLoading || this.props.datosEnviarPDFFinanciero.enviarPDFFinancieroIsLoading }
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text={this.textosCargando()}
            >
            <Page
            title={this.props.detalleCarrito.datosCarritoFinanciero.carDescripcionSeguro}
            breadcrumbs={[{ name: `${this.props.detalleCarrito.datosCarritoFinanciero.carDescripcionSeguro}`, active: true }]}
            >
              <Row>
                <Col lg={8} md={12} sm={12} xs={12}>
                  <div className="container-step">
                    <div className="wrapper-step">
                      <div className="arrow-steps clearfix-step">
                        <div className="step"> {` 1. Cotización `} </div>
                        <div className="step current"> {` 2. Resumen `} </div>
                        <div className="step"> {` 3. Confirmación `} </div>
                        <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {Object.keys(this.props.detalleCarrito.datosCarritoFinanciero).length> 0 &&
              <Row>
                <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                  <ListadoProducto detalleCarrito={this.props.detalleCarrito.datosCarritoFinanciero} handleBack={this.handleBack} />
                </Col>
                {this.props.detalleCarrito.datosCarritoFinanciero.valorTotal !== undefined &&
                <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
                  <ValoresCotizacion paso={"resumen-cotizacion"} detalleCarrito={this.props.detalleCarrito.datosCarritoFinanciero} metodoEnviar={this.onClickEnviarPDF}  />                  
                </Col>
                }
              </Row>
              }
            </Page>
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  detalleCarrito : state.datosCarritoFinanciero,
  datosEnviarPDFFinanciero: state.datosEnviarPDFFinanciero,
  respuestaCarrito : state.datosCotizacionFinanciero
});

const mapDispatchToProps = dispatch => {
  return {
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoFinanciero(data)),
    setCorreo: data => dispatch(fetchEnviarPDFFinanciero(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionFinanciero4)
);
